import { Alert, AlertActions, AlertDescription, AlertTitle } from '../../../components-v2/Alert';
import { Button } from '../../../components-v2/Button';

export interface ArchivedActionBarProps {
	canRestore: boolean;
	isRestoring: boolean;
	onRestore: () => void;
}

export function ArchivedActionBar({ canRestore, isRestoring, onRestore }: ArchivedActionBarProps) {
	return (
		<Alert tone='warning'>
			<AlertTitle>This automation is archived</AlertTitle>
			<AlertDescription>
				{canRestore
					? 'Restore it to edit or enable it. It comes back disabled.'
					: 'Ask an account admin to restore this automation.'}
			</AlertDescription>
			{canRestore ? (
				<AlertActions>
					<Button
						variant='primary'
						onClick={onRestore}
						disabled={isRestoring}
						isLoading={isRestoring}
						aria-label='Restore this automation'
					>
						Restore Automation
					</Button>
				</AlertActions>
			) : null}
		</Alert>
	);
}
